import { post, get } from '../services/request.js'
import dateFormat from '../utils/date'

function tableFormat(row, column, cellValue) {
  let out = ''
  if (cellValue) {
    out = dateFormat(cellValue, 'yyyy-MM-dd hh:mm:ss')
  }
  return out
}

export default {
  init: function(Vue) {
    let vue = Vue.prototype
    vue.$get = get
    vue.$post = post
    vue.$tableFormat = tableFormat
  }
}
